import styled, {css} from 'styled-components'

export const StyledSmallError = styled.small`
    ${({theme: {palette, typography}}) => css`
        color: ${palette.danger['700']};
        ${typography.textSm}
    `}
`

export const StyledSmallSuccess = styled.small`
    ${({theme: {palette, typography}}) => css`
        color: ${palette.success['700']};
        ${typography.textSm}
    `}
`

export const StyledSmall = styled.small`
    ${({theme: {palette, typography}}) => css`
        color: ${palette.neutral['700']};
        ${typography.textSm}
    `}
`
